var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4445 14.8854C6.6997 13.8381 5.07654 12.6056 3.60408 11.2098C2.56886 10.2046 1.78077 8.97917 1.30015 7.62736C0.435269 5.00502 1.44551 2.00295 4.27272 1.1145C5.75859 0.647993 7.38139 1.69856 8.63347 2.61493C9.88602 1.69968 11.5083 0.649203 12.9942 1.1145C15.8214 2.00295 16.8389 5.00502 15.9741 7.62736C15.4934 8.97917 14.7053 10.2046 13.6701 11.2098C12.1977 12.6056 10.5745 13.8381 8.8297 14.8854L8.64073 15L8.4445 14.8854Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLike);
export default __webpack_public_path__ + "static/media/action-like.31de7e617f71469bcd464fc3d590fd92.svg";
export { ForwardRef as ReactComponent };